module.exports = __webpack_public_path__ + "static/img/Permiso(12).eaf1a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(12).jpg
// module id = 9I85
// module chunks = 0